const DEV_EUI_LENGTH = 16 // a DevEUI is always 16 hex characters
const HEX_CHARACTERS_PATTERN = /[0-9A-Fa-f]+/g // splits text into runs of hex characters
const DEV_EUI_LABEL_PATTERN = new RegExp(`DEV[_ ]?EUI\\s*:?\\s*([0-9A-Fa-f]{${DEV_EUI_LENGTH}})`, 'i') // matches a "DEV_EUI:" label followed by its value
const LW_DEV_EUI_POSITION = 3 // TS018-1.0.0 LoRaWAN Device Identification QR Codes for Automated Onboarding

const findLwDevEui = (scannedText: string): string | null => {
    const parts = scannedText.split(':')
    if (parts[0]?.toUpperCase() !== 'LW' || parts.length <= LW_DEV_EUI_POSITION) return null

    const devEui = parts[LW_DEV_EUI_POSITION].trim()
    return new RegExp(`^[0-9A-Fa-f]{${DEV_EUI_LENGTH}}$`).test(devEui) ? devEui : null
}

const findLabeledDevEui = (scannedText: string): string | null => scannedText.match(DEV_EUI_LABEL_PATTERN)?.[1] ?? null

const findAllDevEuiShapedValues = (scannedText: string): string[] =>
    (scannedText.match(HEX_CHARACTERS_PATTERN) ?? []).filter((value) => value.length === DEV_EUI_LENGTH)

export const extractDevEui = (scannedText: string): string => {
    if (!scannedText) return scannedText

    const lwDevEui = findLwDevEui(scannedText)
    if (lwDevEui) return lwDevEui

    const labeledDevEui = findLabeledDevEui(scannedText)
    if (labeledDevEui) return labeledDevEui

    const possibleValues = findAllDevEuiShapedValues(scannedText)
    return possibleValues.length === 1 ? possibleValues[0] : scannedText
}
